import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../helpers/AxiosHelper';

export const reportSlice = createApi({
  reducerPath: 'reports',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Reports'],
  endpoints: (builder) => ({
    getReport: builder.mutation({
      query: (props) => {
        const {
          reportType,
          fromDate,
          toDate,
          formType,
          formTemplateId,
          formTemplate,
          userType,
          selectedContactTypeIds,
          tagIds,
          groups,
          customRoles,
          systemRoles,
          status,
        } = props;
        let url = `/reports/${reportType}?from=${fromDate}&to=${toDate}&formType=${formType}&formTemplateId=${formTemplateId}&formTemplate=${formTemplate}&userType=${userType}&contactTypeIds=${selectedContactTypeIds}&tagIds=${tagIds}&groups=${groups}&customRoles=${customRoles}&systemRoles=${systemRoles}&status=${status}`;
        url = encodeURI(url);
        return {
          url,
          method: 'GET',
        };
      },
    }),
  }),
});

export const {
  useGetReportMutation,
} = reportSlice;
